import { render, staticRenderFns } from "./PlanFormulation.vue?vue&type=template&id=a8fced78&scoped=true"
import script from "./PlanFormulation.vue?vue&type=script&lang=js"
export * from "./PlanFormulation.vue?vue&type=script&lang=js"
import style0 from "./PlanFormulation.vue?vue&type=style&index=0&id=a8fced78&prod&lang=scss&scoped=true"
import style1 from "./PlanFormulation.vue?vue&type=style&index=1&id=a8fced78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fced78",
  null
  
)

export default component.exports